<template>
  <el-dialog :close-on-click-modal="false" :visible="viewVisible" :modal-append-to-body="false" @close="$emit('closeView')">
    <el-tabs v-model="viewName">
      <el-tab-pane label="充电桩详情" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="基本信息" name="basicInformation">
              <el-col :span="12">
                <el-form-item label="充电桩编号：" :label-width="formLabelWidth" prop="pileCode">
                  <label v-text="detailForm.pileCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="充电桩名称：" :label-width="formLabelWidth" prop="name">
                  <label v-text="detailForm.name"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="枪口数量：" :label-width="formLabelWidth" prop="gunCount">
                  <label v-text="detailForm.gunCount"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="额定功率：" :label-width="formLabelWidth" prop="ratedPower">
                  <label v-text="detailForm.ratedPower"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="输出电流范围：" :label-width="formLabelWidth" prop="outputCurrentRange">
                  <label v-text="detailForm.outputCurrentRange"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否启用：" :label-width="formLabelWidth" prop="enabledStateFlag">
                  <label v-if="detailForm.enabledStateFlag" v-text="detailForm.enabledStateFlag.message"></label>
                </el-form-item>
              </el-col>
              <!--                  <el-col :span="12">-->
              <!--                    <el-form-item label="桩运行状态：" :label-width="formLabelWidth" prop="runStatus">-->
              <!--                      <label v-if="detailForm.runStatus" v-text="detailForm.runStatus.message"></label>-->
              <!--                    </el-form-item>-->
              <!--                  </el-col>-->
              <el-col :span="12">
                <el-form-item label="版本：" :label-width="formLabelWidth" prop="nowVersion">
                  <label v-text="detailForm.nowVersion"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="网络链接类型：" :label-width="formLabelWidth" prop="networktype">
                  <label v-text="detailForm.networktype"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="信号幅值：" :label-width="formLabelWidth" prop="signal">
                  <label v-text="detailForm.signal"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="通信模块IMEI号码：" :label-width="formLabelWidth" prop="imei">
                  <label v-text="detailForm.imei"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="SIM卡号码：" :label-width="formLabelWidth" prop="sim">
                  <label v-text="detailForm.sim"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="充电接口标准：" :label-width="formLabelWidth" prop="chargingInterface">
                  <label v-if="detailForm.chargingInterface" v-text="detailForm.chargingInterface.message" autocomplete="off"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="辅源类型：" :label-width="formLabelWidth" prop="auxiliarySourceType">
                  <label v-if="detailForm.auxiliarySourceType" v-text="detailForm.auxiliarySourceType.message" autocomplete="off"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="快慢充：" :label-width="formLabelWidth" prop="fastOrSlow">
                  <label v-if="detailForm.fastOrSlow" v-text="detailForm.fastOrSlow.message+'桩'"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="绑定信息" name="bindingInformation">
              <el-col :span="12">
                <el-form-item label="桩软件协议：" :label-width="formLabelWidth" prop="protocol">
                  <label v-if="detailForm.protocol" v-text="detailForm.protocol.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产厂商：" :label-width="formLabelWidth" prop="manufacturer">
                  <label v-text="detailForm.manufacturer"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="型号：" :label-width="formLabelWidth" prop="pileTypeName">
                  <label v-text="detailForm.pileTypeModel"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运营商：" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="场站：" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="费率组：" :label-width="formLabelWidth" prop="serviceBillingRulesName">
                  <label v-text="detailForm.serviceBillingRulesName"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="日期信息" name="dateInformation">
              <el-col :span="12">
                <el-form-item label="安装日期：" :label-width="formLabelWidth" prop="installDate">
                  <label v-text="detailForm.installDate"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产日期：" :label-width="formLabelWidth" prop="produceDate">
                  <label v-text="detailForm.produceDate"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="免费运营时间：" :label-width="formLabelWidth" prop="freeOperatingTime">
                  <label v-text="detailForm.freeOperatingTime"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="绑定/解绑费率" name="bindingRateForm" v-if="checkPermission(['bee:res:pile:bindingRate'])">
        <el-form :model="bindingRateForm" ref="bindingRateForm" style="height: 400px" size="mini" class="bindingRateForm" :rules="bindingRateFormRules">
          <div v-if="bindingRateForm.serviceBillingRulesId">
            <el-col :span="24">
              <el-form-item label="费率：" :label-width="formLabelWidth" prop="ruleName">
                <label>{{bindingRateForm.ruleName}}</label>
                <el-button size="mini" plain style="margin-left: 10px" @click="unbinding">解绑</el-button>
              </el-form-item>
            </el-col>
          </div>
          <div v-else>
            <el-col :span="24">
              <el-form-item label="费率：" :label-width="formLabelWidth" prop="serviceBillingRulesIdTemp">
                <el-select autocomplete="off" v-model="bindingRateForm.serviceBillingRulesIdTemp">
                  <el-option v-for="item in serviceBillingRulesSelect" :key="item.id"
                             v-bind:label="item.ruleName" v-bind:value="item.id"></el-option>
                </el-select>
                <el-button size="mini" plain style="margin-left: 10px" @click="dobinding">绑定</el-button>
              </el-form-item>
            </el-col>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  export default {
    name: "customizeView",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation', 'bindingInformation', 'dateInformation'],
        formLabelWidth: '150px',
        bindingRateFormRules:{
          serviceBillingRulesIdTemp:[{required: true, message: '请选择费率', trigger: 'blur'}]
        },
      }
    },
    props:{
      viewVisible:{
        type:Boolean,
        required: true
      },
      detailForm: {},
      bindingRateForm: {},
      serviceBillingRulesSelect: {},
      serviceBillingRulesIdTemp: ''
    },
    methods:{
      unbinding(){
        this.$emit("unbinding")
      },
      dobinding(){
        this.$emit("dobinding",this.$refs["bindingRateForm"])
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/deviceManager/customizeView.vue